import React, { useContext } from 'react';
import TenantFeatureContext from '../../../contexts/TenantContext';
import { PROJECT_CONFIG_LABELS } from './projectFormSchema';

const CONFIG_DESCRIPTIONS = {
  full: 'Document management, in-app inspections, findings, and scheduling.',
  e_swp: 'Document management and site map editing. No in-app inspections or findings.',
  it: 'Document storage and inspection tracking via an external platform.',
  it_eswp: 'Document storage/editing and inspection tracking via an external platform.',
  map: 'Site map editing. Document storage only — no PDF annotation or inspections.',
  it_map: 'Site map editing and external inspection tracking. Document storage only — no PDF annotation.',
};

const STANDARD_CONFIGS = ['full', 'e_swp', 'map'];
const EVP_CONFIGS = ['it', 'it_eswp', 'it_map'];

function ConfigCard({ configKey, onSelect }) {
  return (
    <button
      type='button'
      className='project-config-card'
      onClick={() => onSelect(configKey)}
    >
      <div className='project-config-card__title'>
        {PROJECT_CONFIG_LABELS[configKey]}
      </div>
      <div className='project-config-card__description'>
        {CONFIG_DESCRIPTIONS[configKey]}
      </div>
    </button>
  );
}

export default function ProjectConfigSelector({ onSelect, onClose }) {
  const featureContext = useContext(TenantFeatureContext);
  const evpEnabled = featureContext.tenantHasFeature('External Verification Projects');
  const pdfEditingEnabled = featureContext.tenantHasFeature('PDF Editing');
  const siteMapEditorEnabled = featureContext.tenantHasFeature('Site Map - Editor Updates');

  const visibleStandardConfigs = [
    'full',
    ...(pdfEditingEnabled ? ['e_swp'] : []),
    ...(siteMapEditorEnabled ? ['map'] : []),
  ];

  const visibleEvpConfigs = evpEnabled ? [
    'it',
    ...(pdfEditingEnabled ? ['it_eswp'] : []),
    ...(siteMapEditorEnabled ? ['it_map'] : []),
  ] : [];

  return (
    <div className='project-config-selector__overlay' onClick={onClose}>
      <div
        className='project-config-selector'
        onClick={(e) => e.stopPropagation()}
      >
        <div className='project-config-selector__header'>
          <h2>Select Project Configuration</h2>
          <button
            type='button'
            className='project-config-selector__close'
            onClick={onClose}
            aria-label='Close'
          >
            &times;
          </button>
        </div>

        <div className='project-config-selector__grid'>
          {visibleStandardConfigs.map((key) => (
            <ConfigCard key={key} configKey={key} onSelect={onSelect} />
          ))}
        </div>

        {visibleEvpConfigs.length > 0 && (
          <>
            <div className='project-config-selector__divider'>
              <span>External Verification Projects</span>
            </div>
            <div className='project-config-selector__grid'>
              {visibleEvpConfigs.map((key) => (
                <ConfigCard key={key} configKey={key} onSelect={onSelect} />
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
